<template>
  <div>
    <main role="main">
      <div  class="container">       
        <section id="intro">
            <h1 data-aos="fade-right" data-aos-delay="200">{{ $t("home.intro.h1") }}</h1>
            <div class="link" data-aos="fade-left" data-aos-delay="400">
                <b-link href="#offers">{{ $t("home.intro.link.offers") }}</b-link>
            </div>
        </section>
      </div>
      <section id="offers" data-aos="fade-up" data-aos-delay="500">
        <CarouselOffers3d/>
      </section>
      <section id="widget" class="container">
        <WidgetExample :reload="reload"/>
      </section>
    </main>
  </div>
</template>

<script>
import CarouselOffers3d from '../components/CarouselOffers3d.vue'
import WidgetExample from '../components/WidgetExample.vue'

export default {
  name: 'HomePage',
  components: {
    CarouselOffers3d,
    WidgetExample
  },
  props: {
    reload: Boolean
  }
}
</script>

<style>
  #intro {
    padding: 25px;
  }
  #intro h1 {  
    line-height: 1.43;
    font-size: 21px;
    font-weight: 600;
    text-align: center;
  }
  #intro .link {
    font-size: 10px;
    font-weight: 600;
    margin-top: 50px;
    text-align: center;
  }
  #intro .link a {
    font-size: 21px;
    font-weight: 600;
  }

  .carousel-3d-controls .prev {
    left: 0 !important;
    color: transparent !important;
    background: url(../../assets/left-handle.svg) no-repeat;
    background-size: auto 100%;
  }
  .carousel-3d-controls .next {
    right: 0 !important;
    color: transparent !important;
    background: url(../../assets/right-handle.svg) no-repeat;
    background-size: auto 100%;
  }

  #widget {
    margin: 100px auto;
  }
  #widget .nav-tabs .nav-link {
    color: #0cb2d5 !important;
  }
  #widget .nav-tabs .nav-link.active {
    background: #0cb2d5 !important;
    color: #fff !important;

  }

  /* desktop */

  @media (min-width: 850px){
    .carousel-3d-controls {
      display: none;
    }
  }
  @media (min-width: 992px){
    #intro h1 {
      margin-top: 40px;
    }
  }
  @media (min-width: 1200px){
    #intro h1 {
      font-size: 46px;
      text-align: center;
      margin: 100px 0;
    }
    #intro .link {
      font-size: 12px;;
    }
    #intro .link a {
      font-size: 31.6px;
    }
  }
</style>
